module.exports = "/_next/static/images/img__1_desktop-4736f8a7bff06bd6611de6f2fb8439e9.png";